import { inject, ref } from 'vue';

export default function countBadgeHandler() {
  const axios = inject('$axios');
  const overallCountBadge = ref(0);
  const sectionCountBadgeUnread = ref([]);
  const overallCountUnread = async () => {
    try {
      const { data } = await axios.get('/api/push-notifications/notif-count');
      overallCountBadge.value = data.data.overall.unreadCount;
      console.log('Badge', overallCountBadge.value);
    } catch (error) {
      console.log(error);
    }
  };
  const sectionCountUnreadHandler = async () => {
    try {
      const { data } = await axios.get('/api/push-notifications/notif-count');
      sectionCountBadgeUnread.value = data.data.bySection;
      console.log('render', data.data.bySection);
    } catch (error) {
      console.log(error);
    }
  };
  return {
    overallCountUnread,
    overallCountBadge,
    sectionCountUnreadHandler,
    sectionCountBadgeUnread
  };
}
